/* AUTAVEX — Подушки: легке завантаження фото */
(function(){
var D=window.AVP;if(!D)return;
var C=D.CDN;
D.DZ[4][1]='FullSizeRender_e622ab9d-d41e-41fc-b377-8acdb9311a06.jpg?v=1786307518';
function px(u,w){return C+u+(u.indexOf('?')>-1?'&':'?')+'width='+w}
var st={g:0,dz:0,kit:0,size:0,mode:0,col:0,colB:4,stitch:0,thr:0,files:[]};
function Q(i){return document.getElementById(i)}
function money(v){return Math.round(v).toLocaleString('uk-UA')+' \u20b4'}
function shade(h){var r=parseInt(h.substr(1,2),16),g=parseInt(h.substr(3,2),16),b=parseInt(h.substr(5,2),16);
 r=Math.round(r*.62);g=Math.round(g*.62);b=Math.round(b*.62);
 return '#'+[r,g,b].map(function(v){return ('0'+v.toString(16)).slice(-2)}).join('')}
function stars(v){var f=Math.floor(v),h=(v-f)>=0.4,o='';for(var i=0;i<f;i++)o+='\u2605';if(h)o+='<span style="opacity:.45">\u2605</span>';for(var j=f+(h?1:0);j<5;j++)o+='\u2606';return o}
function hasEmb(){return st.files.length>0||(Q('pwTxt')&&Q('pwTxt').value.trim())}
function total(){var s=D.KITS[st.kit][2];if(st.mode===1)s+=D.DUOUP;if(hasEmb())s+=D.EMB;return s}
function colName(){return st.mode===0?D.SOLID[st.col][0]:(D.SOLID[st.col][0]+' + '+D.SOLID[st.colB][0])}

/* —— галерея: одне велике фото в DOM —— */
function gal(){
  var stg=Q('pwStage'),th=Q('pwThumbs');
  if(!stg||stg.dataset.b)return;
  stg.dataset.b='1';
  stg.innerHTML='<div class="on"><img id="pwBig" alt=""></div>';
  var h='';
  for(var i=0;i<D.GAL.length;i++)
    h+='<button type="button" class="'+(i===0?'on':'')+'" data-g="'+i+'"><img src="'+px(D.GAL[i],160)+'" alt="" loading="lazy" decoding="async"></button>';
  th.innerHTML=h;
}
function showBig(){
  var im=Q('pwBig');if(!im)return;
  var url=px(D.GAL[st.g],900);
  if(im.getAttribute('src')!==url)im.setAttribute('src',url);
  var tb=Q('pwThumbs').children;
  for(var i=0;i<tb.length;i++)tb[i].className=(i===st.g?'on':'');
  Q('pwCnt').textContent=(st.g+1)+' / '+D.GAL.length;
}

function buildOnce(){
  gal();
  var dz=Q('pwDz');
  if(dz&&!dz.dataset.b){dz.dataset.b='1';
    dz.innerHTML=D.DZ.map(function(d,i){return '<button type="button" class="'+(i===0?'on':'')+'" data-dz="'+i+'"><span class="ph"><img src="'+px(d[1],320)+'" alt="" loading="lazy" decoding="async"></span><b>'+d[0]+'</b></button>'}).join('')}
  var kt=Q('pwKits');
  if(kt&&!kt.dataset.b){kt.dataset.b='1';
    kt.innerHTML=D.KITS.map(function(k,i){return '<button type="button" class="kit'+(i===0?' on':'')+'" data-kit="'+i+'"><span class="pic"><img src="'+px(k[3],200)+'" alt="" loading="lazy" decoding="async"></span><span class="t"><b>'+k[0]+'</b><span>'+k[1]+'</span></span><span class="p">'+money(k[2])+'</span></button>'}).join('')}
  var sz=Q('pwSizes');
  if(sz&&!sz.dataset.b){sz.dataset.b='1';
    sz.innerHTML=D.SIZES.map(function(z,i){return '<button type="button" class="'+(i===0?'on':'')+'" data-size="'+i+'">'+z[0]+'</button>'}).join('')}
  var md=Q('pwMode');
  if(md&&!md.dataset.b){md.dataset.b='1';
    md.innerHTML='<button type="button" class="on" data-mode="0">\u041e\u0434\u043d\u043e\u0442\u043e\u043d\u043d\u0430</button><button type="button" data-mode="1">\u0414\u0432\u043e\u0442\u043e\u043d\u043d\u0430 +'+D.DUOUP+' \u20b4</button>'}
  var cl=Q('pwColors');
  if(cl&&!cl.dataset.b){cl.dataset.b='1';
    var row=function(key,def){return '<div class="dots" data-row="'+key+'">'+D.SOLID.map(function(c,i){
      return '<button type="button" class="'+(i===def?'on':'')+'" title="'+c[0]+'" data-'+key+'="'+i+'" style="background:'+c[1]+' url('+px(c[2],96)+') center/cover"></button>'}).join('')+'</div>'};
    cl.innerHTML='<p class="mini" data-l="a" style="display:none">\u041e\u0441\u043d\u043e\u0432\u043d\u0438\u0439 \u043a\u043e\u043b\u0456\u0440 (\u0437\u043e\u0432\u043d\u0456 \u0442\u0430 \u0431\u043e\u043a\u0438)</p>'+row('col',0)+
      '<p class="mini" data-l="b" style="display:none">\u0414\u0440\u0443\u0433\u0438\u0439 \u043a\u043e\u043b\u0456\u0440 (\u0432\u0441\u0442\u0430\u0432\u043a\u0430 \u0432\u0441\u0435\u0440\u0435\u0434\u0438\u043d\u0456 \u043f\u043e\u0434\u0443\u0448\u043a\u0438)</p>'+row('colB',4)}
  ['pwStitch','pwThr'].forEach(function(id,n){
    var el=Q(id);if(!el||el.dataset.b)return;el.dataset.b='1';
    var key=(n===0?'stitch':'thr');
    el.innerHTML=D.THR.map(function(c,i){
      var bg=c[2]?'linear-gradient(135deg,'+c[1]+' 0%,#FFFFFF 38%,'+c[1]+' 62%,'+shade(c[1])+' 100%)':c[1];
      return '<button type="button" class="'+(i===0?'on':'')+'" title="'+c[0]+'" data-'+key+'="'+i+'" style="background:'+bg+'"></button>'}).join('');
  });
  var rv=Q('pwRev');
  if(rv&&!rv.dataset.b){rv.dataset.b='1';
    rv.innerHTML=D.REV.map(function(r){return '<div class="rv"><span class="st">'+stars(r[0])+'</span> <b style="font-family:\'IBM Plex Mono\',monospace;font-size:12px">'+r[0].toFixed(1)+'</b><p>'+r[1]+'</p></div>'}).join('')}
}
function mark(sel,idx){
  var b=document.querySelectorAll(sel);
  for(var i=0;i<b.length;i++)b[i].className=(b[i].classList.contains('kit')?('kit'+(i===idx?' on':'')):(i===idx?'on':''));
}
function update(){
  showBig();
  mark('#pwDz button',st.dz);Q('pwNDz').textContent=D.DZ[st.dz][0];
  mark('#pwKits .kit',st.kit);Q('pwNKit').textContent=D.KITS[st.kit][0];
  var big=(st.kit>1);
  Q('pwSizes').style.display=big?'grid':'none';
  Q('pwSizeH').style.display=big?'block':'none';
  Q('pwNSize').textContent=big?D.SIZES[st.size][0]:'';
  mark('#pwSizes button',st.size);
  mark('#pwMode button',st.mode);
  var duo=(st.mode===1);
  var la=document.querySelector('#pwColors [data-l="a"]'),lb=document.querySelector('#pwColors [data-l="b"]'),rb=document.querySelector('#pwColors [data-row="colB"]');
  if(la)la.style.display=duo?'block':'none';
  if(lb)lb.style.display=duo?'block':'none';
  if(rb)rb.style.display=duo?'flex':'none';
  mark('#pwColors [data-row="col"] button',st.col);
  mark('#pwColors [data-row="colB"] button',st.colB);
  Q('pwNCol').textContent='\u041e\u0431\u0440\u0430\u043d\u043e: '+colName();
  mark('#pwStitch button',st.stitch);Q('pwNSt').textContent=D.THR[st.stitch][0];
  mark('#pwThr button',st.thr);Q('pwNThr').textContent=D.THR[st.thr][0];
  Q('pwSum').textContent=money(total());
}
document.addEventListener('click',function(e){
  var b=e.target.closest('#pw [data-g],#pw [data-dz],#pw [data-kit],#pw [data-size],#pw [data-mode],#pw [data-col],#pw [data-colB],#pw [data-stitch],#pw [data-thr]');
  if(b){
    var y=window.scrollY,d=b.dataset;
    if(d.g!==undefined)st.g=+d.g;
    if(d.dz!==undefined)st.dz=+d.dz;
    if(d.kit!==undefined)st.kit=+d.kit;
    if(d.size!==undefined)st.size=+d.size;
    if(d.mode!==undefined)st.mode=+d.mode;
    if(d.col!==undefined)st.col=+d.col;
    if(d.colB!==undefined)st.colB=+d.colB;
    if(d.stitch!==undefined)st.stitch=+d.stitch;
    if(d.thr!==undefined)st.thr=+d.thr;
    update();
    setTimeout(function(){window.scrollTo(0,y)},0);
    return;
  }
  var a=e.target.closest('#pwNav a');
  if(a){
    var t=a.dataset.t,links=document.querySelectorAll('#pwNav a'),secs=document.querySelectorAll('#pw .sec');
    for(var i=0;i<links.length;i++)links[i].className=(links[i]===a?'on':'');
    for(var j=0;j<secs.length;j++)secs[j].className='sec'+(secs[j].id==='pw-'+t?' on':'');
    window.scrollTo({top:0,behavior:'smooth'});
  }
},false);
window.AVP_STATE=st;window.AVP_TOTAL=total;window.AVP_COLNAME=colName;
function boot(){
  if(!Q('pw'))return;
  buildOnce();update();
  var fi=Q('pwFile');
  if(fi){fi.setAttribute('multiple','multiple');
    fi.addEventListener('change',function(e){
      var list=Array.prototype.slice.call(e.target.files||[]),ok=Q('pwUpok');
      if(list.length>2)list=list.slice(0,2);
      st.files=list.map(function(f){return f.name});
      if(st.files.length){ok.className='upok on';ok.textContent='\u0424\u0430\u0439\u043b\u0438: '+st.files.join(', ')+' \u00b7 +'+money(D.EMB)+' \u0437\u0430 \u0432\u0438\u0448\u0438\u0432\u043a\u0443'}
      update();
    })}
  var tx=Q('pwTxt');
  if(tx)tx.addEventListener('input',function(){Q('pwSum').textContent=money(total())});
}
if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',boot)}else{boot()}
})();
